// export.ts — CSV export of the climbing tick list (all local; nothing leaves the device).

import type { Climb } from "./store";
import { ASCENT_LABELS, DISCIPLINE_LABELS, ENVIRONMENT_LABELS } from "./store";

function cell(v: string | number): string {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
function csv(headers: string[], rows: (string | number)[][]): string {
  return [headers, ...rows].map((r) => r.map(cell).join(",")).join("\n");
}

/** Full CSV: Date, Grade, Environment, Venue, Discipline, Style, Ascent, Attempts, Sent, Project, Shoe, Partner, Note. */
export function climbsCsv(climbs: Climb[]): string {
  return csv(
    ["Date", "Grade", "Environment", "Venue", "Discipline", "Style", "Ascent", "Attempts", "Sent", "Project", "Shoe", "Partner", "Note"],
    climbs.map((c) => [
      c.climbed_on,
      c.grade,
      ENVIRONMENT_LABELS[c.environment] ?? c.environment,
      c.venue,
      DISCIPLINE_LABELS[c.discipline] ?? c.discipline,
      c.style.join(" "),
      ASCENT_LABELS[c.ascent] ?? c.ascent,
      c.attempts,
      c.sent ? "yes" : "no",
      c.project ? "yes" : "no",
      c.shoe,
      c.partner,
      c.note ?? "",
    ]),
  );
}

export function buildExport(climbs: Climb[]): { csv: string; filename: string } {
  const stamp = new Date().toISOString().slice(0, 10);
  return { csv: climbsCsv(climbs), filename: `send-log-${stamp}.csv` };
}
